import './customer-card-only.component.ajscss';

import { copy, IComponentController, IComponentOptions, isArray, isDefined, isUndefined } from 'angular';

import { ChannelType, Customer, CustomerAddress } from '@contact/upgrade';

import templateUrl from './customer-card-only.component.html';
import { IModalParamCustomerCardOnly, IModalParamCustomerCardOnlyResult } from './model/modal-param-customer-card-only';

class CustomerCardOnlyViewCtrl implements IComponentController {
  customerCard: Customer | undefined;

  currentUri: string;
  currentAddress: CustomerAddress;
  mailAddresses: CustomerAddress[];

  // modal popin
  close: Function;
  dismiss: Function;
  resolve: Function;
  param: IModalParamCustomerCardOnly;
  closeCallBack: Function;
  // if assigned csr is not current and we check and uncheck restore

  constructor(private $i18next: any) {
    this.currentUri = '';
    this.mailAddresses = [];
  }

  $onInit(): void {
    // read the modal parameters
    this.param = this.resolve();

    /**
     * If a uri is given, select it by default
     */
    this.currentUri = copy(this.param.selectedUri || '');

    if (isDefined(this.param.customerCard)) {
      this.customerCard = copy(this.param.customerCard);

      if (this.param && this.param.customerAddress && isArray(this.param.customerAddress)) {
        this.mailAddresses = this.param.customerAddress.filter(adr => adr.channel.type === ChannelType.MAIL);

        /**
         * find the IasId matching the email address
         */
        this.mailAddresses.forEach((_adr: CustomerAddress) => {
          if (_adr.uri === this.currentUri) this.currentAddress = _adr;
        });

        /**
         *  if no one is selected, choose the first
         */
        if (isUndefined(this.currentAddress)) {
          this.currentAddress = this.param.customerAddress[0];
        }
      }
    }
  }

  readableCardFirstName(card: Customer): string {
    let ret = '';
    if (isDefined(card)) {
      if (card.lastname === '' && card.firstname === '') {
        ret = this.$i18next.t('agent:contact.info.contact');
      } else {
        ret = card.firstname;
      }
    }
    return ret;
  }

  readableCardLastName(card: Customer): string {
    let ret = '';
    if (isDefined(card)) {
      if (card.lastname === '' && card.firstname === '') {
        ret = this.$i18next.t('agent:contact.info.unvalued_contact');
      } else {
        ret = card.lastname;
      }
    }
    return ret;
  }

  // return the IasId of the selected mail address
  validate(): void {
    let _res: IModalParamCustomerCardOnlyResult = {
      id: '',
      iasId: '',
      uri: '',
    };
    _res.iasId = this.currentAddress.externalId ? this.currentAddress.externalId : '';
    _res.uri = this.currentAddress.uri;
    this.close({ $value: _res });
  }

  cancel(): void {
    this.dismiss();
  }
}

export class CustomerCardOnly implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    close: '&',
    dismiss: '&',
    resolve: '&',
  };
  controller = ['$i18next', CustomerCardOnlyViewCtrl];
}

export default 'contactCustomerCardOnly';
